/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
import { Breadcrumb, Button, Input, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { ReloadOutlined, MinusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import ActionButton from '../Global/ActionsButton';
import { deleteBundle, getAllBundlesPaged } from '../../redux/bundleSlice';
import BundleDrawer from './BundleDrawer';
import { formatEnumValue } from '../../Utils/ArrayToObject';

const Bundle = () => {
const { bundles } = useSelector((state) => state.bundles);
const [isDrawerOpened, setIsDrawerOpened] = useState(false);
const [bundleId, setBundleId] = useState(null);
const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [search, setSearch] = useState('');
const searchTimerRef = useRef(null);
const [sortedInfo, setSortedInfo] = useState({ columnKey: null, order: null });
const dispatch = useDispatch();

const columnSortMap = {
	id: 'id',
	name: 'name',
	numberOfRides: 'numberOfRides',
	numberOfDays: 'numberOfDays',
	price: 'price',
};

const handleTableChange = (_, __, sorter, extra) => {
	if (extra?.action !== 'sort') return;
	setSortedInfo(sorter.order ? { columnKey: sorter.columnKey, order: sorter.order } : { columnKey: null, order: null });
	setCurrentPage(1);
};

const fetchBundles = () => {
const sortBy = (sortedInfo.columnKey && columnSortMap[sortedInfo.columnKey]) || 'id';
const sortDirection = sortedInfo.order === 'ascend' ? 'ASC' : 'DESC';
dispatch(
getAllBundlesPaged({
page: currentPage - 1,
size: pageSize,
search,
sortBy,
sortDirection,
}),
)
.unwrap()
.catch(() => {
message.error('Error while fetching bundles');
});
};

useEffect(() => {
fetchBundles();
}, [currentPage, pageSize, search, sortedInfo]);

const closeDrawer = () => {
setIsDrawerOpened(false);
setBundleId(null);
fetchBundles();
};

const openDrawer = (record) => {
setIsDrawerOpened(true);
if (record) setBundleId(record.id);
};

const { Settings } = useSelector((state) => state.settings);

const handleDelete = (id) => {
dispatch(deleteBundle(id))
.unwrap()
.then(() => {
message.success('Bundle deleted successfully');
fetchBundles();
})
.catch(() => {
message.error('Error occurred while deleting bundle');
});
};

const currencyRender = () => {
return <span>{Settings?.settingsData?.currency || '\u20ac'}</span>;
};

const data = bundles?.bundleList ? Object.values(bundles.bundleList) : [];

const columns = [
{
title: 'ID',
dataIndex: 'id',
key: 'id',
sorter: true,
sortOrder: sortedInfo.columnKey === 'id' ? sortedInfo.order : null,
},
{
title: 'Name',
dataIndex: 'name',
key: 'name',
sorter: true,
sortOrder: sortedInfo.columnKey === 'name' ? sortedInfo.order : null,
},
{
title: 'Number of Rides',
dataIndex: 'numberOfRides',
key: 'numberOfRides',
sorter: true,
sortOrder: sortedInfo.columnKey === 'numberOfRides' ? sortedInfo.order : null,
},
{
title: 'Number of Days',
dataIndex: 'numberOfDays',
key: 'numberOfDays',
sorter: true,
sortOrder: sortedInfo.columnKey === 'numberOfDays' ? sortedInfo.order : null,
},
{
title: 'Price',
key: 'price',
render: (record) => {
return (
<div>
{currencyRender()}
{record.price}
</div>
);
},
sorter: true,
sortOrder: sortedInfo.columnKey === 'price' ? sortedInfo.order : null,
},
{
title: 'Allowed Days',
key: 'allowedDays',
render: (record) => {
const allowedDaysList = record?.allowedDays?.split(',');
return allowedDaysList?.length > 0 ? (
<span>
{allowedDaysList?.map((item) => {
return (
<span key={item} style={style.tags}>
{formatEnumValue(item)}
</span>
);
})}
</span>
) : (
<MinusOutlined />
);
},
},
{
title: 'Actions',
key: 'actions',
render: (text, record) => (
<ActionButton
blockEdit={record.purchased}
record={record}
onDelete={() => handleDelete(record.id)}
onEdit={() => openDrawer(record)}
/>
),
},
];

return (
<>
<div style={style.inlineContent}>
<div
style={{
display: 'flex',
alignContent: 'center',
alignItems: 'center',
float: 'left',
marginBottom: 8,
}}>
<Breadcrumb
style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
items={[
{
title: 'Bundles',
},
]}
/>
<Button type='default' size='small' onClick={() => fetchBundles()}>
<ReloadOutlined />
</Button>
</div>

<div
style={{
...style.inlineContent,
float: 'right',
marginBottom: 8,
}}>
<Input.Search
placeholder='Search'
style={{ margin: '0 8px 8px 0' }}
allowClear
onSearch={(val) => {
if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
setCurrentPage(1);
setSearch(val);
}}
onChange={(e) => {
const val = e.target.value;
if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
searchTimerRef.current = setTimeout(() => {
setCurrentPage(1);
setSearch(val);
}, 400);
}}
/>

<Button
type='default'
style={{ float: 'right', marginBottom: 8 }}
onClick={() => openDrawer()}>
Add Bundle
</Button>
</div>
</div>
<CustomTableComponentsPageable
isMakingApiCall={bundles?.loading}
columns={columns}
dataArray={data}
handleDoubleClickRow={(record) => {
if (record.purchased) return;
openDrawer(record);
}}
handleSelectedRow={() => {}}
onTableChange={handleTableChange}
pagination={{
current: currentPage,
pageSize,
total: bundles?.total || 0,
onChange: (page, size) => {
setCurrentPage(page);
setPageSize(size);
},
}}
/>
{isDrawerOpened && (
<BundleDrawer onClose={closeDrawer} bundleId={bundleId} dispatch={dispatch} />
)}
</>
);
};

export default Bundle;